<div class="fundo" role="dialog" aria-modal="true" [attr.aria-label]="titulo">
  <div class="modal">
    <div class="modal-cab">
      <div class="cab-ico" aria-hidden="true"><svg class="i" viewBox="0 0 24 24"><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="m13.5 6.5 4 4" /></svg></div>
      <div class="cab-txt">
        <b>{{ titulo }}</b>
        <span>{{ linhas.length }} agendamento{{ linhas.length > 1 ? 's' : '' }} · só os campos preenchidos são aplicados</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <!-- Formulário -->
    <div class="modal-corpo" *ngIf="!resultados">
      <div class="mini-wrap">
        <table class="mini">
          <thead>
            <tr><th>Hora</th><th>Paciente</th><th>Status</th><th>Classif.</th><th>Convênio</th><th>Travas</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let l of linhas">
              <td><b>{{ l.hrInicio }}</b> <span class="selo cinza" *ngIf="l.tipo === 'EXAME'">EXAME</span></td>
              <td>{{ l.paciente.nmPaciente || '—' }}</td>
              <td><span class="selo cinza">{{ l.dsStatusAgenda || l.ieStatusAgenda }}</span></td>
              <td>{{ l.dsClassifAgenda || '—' }}</td>
              <td *ngIf="exibicaoConvenio(l.convenio.cdConvenio, l.convenio.dsConvenio, l.categoria.dsCategoria) as ec" [title]="ec.tooltip">{{ ec.linha1 }}{{ ec.sub ? ' · ' + ec.sub : '' }}</td>
              <td>
                <ng-container *ngIf="travas(l).length; else livre">
                  <span *ngFor="let t of travas(l)" class="selo" [class.bad]="t.tom === 'bad'" [class.warn]="t.tom === 'warn'">{{ t.texto }}</span>
                </ng-container>
                <ng-template #livre><span class="selo ok">livre para alterar</span></ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="alerta bad" *ngIf="temReservadoBloqueado">
        <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
        <div>Há horário reservado na seleção. Só a supervisão altera: ele é pulado em todos os campos.</div>
      </div>

      <div class="form-lote">
        <!-- Status -->
        <div class="campo-lote">
          <label class="rot" for="lSt">Status</label>
          <div>
            <select id="lSt" [(ngModel)]="e.status">
              <option [ngValue]="null">Manter</option>
              <option *ngFor="let s of opcoesStatus" [ngValue]="s.valor">{{ s.rotulo }}</option>
            </select>
            <p class="dica">Para cancelar use "Cancelar", que pede motivo e regera o horário.</p>
          </div>
        </div>

        <!-- Classificação -->
        <div class="campo-lote">
          <label class="rot" for="lCls">Classificação</label>
          <div>
            <select id="lCls" [(ngModel)]="e.classif" [disabled]="!!trava('classificacao')">
              <option [ngValue]="null">Manter</option>
              <option *ngFor="let c of opcoesClassif" [ngValue]="c.valor">{{ c.rotulo }}</option>
            </select>
            <div class="trava" *ngIf="trava('classificacao') as m">
              <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>{{ m }}
            </div>
            <div class="trava" *ngIf="retornoEscolhido">
              <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
              O limite de retornos da agenda é conferido ao gravar{{ supervisor ? '; supervisão pode passar' : '' }}.
            </div>
          </div>
        </div>

        <!-- Convênio / categoria -->
        <div class="campo-lote">
          <label class="rot" for="lConv">Convênio / categoria</label>
          <div>
            <div class="linha">
              <select id="lConv" [ngModel]="e.cdConvenio" (ngModelChange)="trocarConvenio($event)" [disabled]="carregandoConvenios">
                <option [ngValue]="null">{{ carregandoConvenios ? 'Carregando...' : 'Manter' }}</option>
                <option *ngFor="let c of convenios" [ngValue]="c.codigo">{{ c.descricao }}</option>
              </select>
              <select
                aria-label="Categoria"
                [(ngModel)]="e.cdCategoria"
                [disabled]="e.cdConvenio === null || e.cdConvenio === CONVENIO_CARTAO || carregandoCategorias"
              >
                <ng-container *ngIf="e.cdConvenio === CONVENIO_CARTAO; else categoriasNormais">
                  <option [ngValue]="null">{{ carregandoPlanos ? 'Lendo os planos...' : 'Plano de cada paciente' }}</option>
                </ng-container>
                <ng-template #categoriasNormais>
                  <option [ngValue]="null">{{ e.cdConvenio === null ? 'Manter' : carregandoCategorias ? 'Carregando...' : 'Selecione...' }}</option>
                  <option *ngFor="let c of categorias" [ngValue]="'' + c.codigo">{{ c.descricao }}</option>
                </ng-template>
              </select>
            </div>
            <p class="dica" *ngIf="conveniosCarregados && !convenios.length">Nenhum convênio liberado para este médico nesta unidade</p>
            <div class="trava" *ngIf="e.cdConvenio === CONVENIO_CARTAO && !carregandoPlanos">
              <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
              Convênio {{ CONVENIO_CARTAO }}: cada paciente fica com a categoria do próprio plano{{ semPlano224 ? '; ' + semPlano224 + ' sem plano ativo será(ão) pulado(s)' : '' }}.
            </div>
          </div>
        </div>

        <!-- Especialidade (consulta) -->
        <div class="campo-lote">
          <label class="rot" for="lEsp">Especialidade</label>
          <div>
            <select id="lEsp" [(ngModel)]="e.cdEspecialidade" [disabled]="!!trava('especialidade') || carregandoEspecialidades">
              <option [ngValue]="null">{{ carregandoEspecialidades ? 'Carregando...' : 'Manter' }}</option>
              <option *ngFor="let x of especialidades" [ngValue]="x.cdEspecialidade">
                {{ x.dsEspecialidade }}{{ x.ieTitular === 'S' ? ' (titular da agenda)' : '' }}
              </option>
            </select>
            <div class="trava" *ngIf="trava('especialidade') as m; else infoEsp">
              <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>{{ m }}
            </div>
            <ng-template #infoEsp>
              <div class="trava">
                <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
                <ng-container *ngIf="especialidadeAtual">Atual: {{ especialidadeAtual }} · </ng-container>
                Horários em andamento ou com atendimento são pulados.
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Procedimento (exame) -->
        <div class="campo-lote">
          <span class="rot">Procedimento (exame)</span>
          <div>
            <ng-container *ngIf="!trava('procedimento'); else travaProc">
              <div class="exame-sel" *ngIf="exameEscolhido; else buscaProc">
                <span><b>{{ exameEscolhido.dsProcExame }}</b></span>
                <button type="button" class="link" (click)="removerExame()">Manter o atual</button>
              </div>
              <ng-template #buscaProc>
                <input
                  type="search"
                  aria-label="Buscar exame"
                  placeholder="Digite 3+ letras para trocar o exame..."
                  autocomplete="off"
                  [(ngModel)]="buscaExame"
                  (ngModelChange)="aoDigitarExame()"
                />
                <div class="lista-exames" *ngIf="exames.length">
                  <button type="button" *ngFor="let x of exames" (click)="escolherExame(x)">
                    <span>{{ x.dsProcExame }}</span>
                    <span class="selo warn" *ngIf="x.ieTemValor === 'N'">sem valor</span>
                  </button>
                </div>
                <p class="dica" *ngIf="buscandoExame">Buscando...</p>
                <p class="dica" *ngIf="!buscandoExame && vazioExame">{{ vazioExame }}</p>
              </ng-template>
              <p class="dica">Atual: {{ linhas[0].dsExame || '—' }} · só exames vinculados a esta agenda</p>
            </ng-container>
            <ng-template #travaProc>
              <select disabled aria-label="Procedimento"><option>Manter</option></select>
              <div class="trava">
                <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>{{ trava('procedimento') }}
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Tipo de atendimento e tipo de consulta (consulta) -->
        <div class="campo-lote">
          <label class="rot" for="lTA">Tipo de atendimento</label>
          <div>
            <select id="lTA" [(ngModel)]="e.tipoAtendimento" [disabled]="!!trava('tipoAtendimento') || carregandoTipos">
              <option [ngValue]="null">{{ carregandoTipos ? 'Carregando...' : 'Manter' }}</option>
              <option *ngFor="let t of tiposAtendimento" [ngValue]="t.valor">{{ t.descricao }}</option>
            </select>
            <div class="trava" *ngIf="trava('tipoAtendimento') as m">
              <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>{{ m }}
            </div>
          </div>
        </div>

        <div class="campo-lote">
          <label class="rot" for="lTC">Tipo de consulta</label>
          <div>
            <select id="lTC" [(ngModel)]="e.tipoConsulta" [disabled]="!!trava('tipoConsulta')">
              <option value="manter">Manter</option>
              <option value="reagendamento">Reagendamento Online</option>
              <option value="limpar">Limpar</option>
            </select>
            <div class="trava" *ngIf="trava('tipoConsulta') as m">
              <svg class="i sm" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>{{ m }}
            </div>
          </div>
        </div>

        <!-- Observação -->
        <div class="campo-lote">
          <span class="rot">Observação</span>
          <div>
            <label class="check"><input type="checkbox" [(ngModel)]="e.alterarObservacao" (ngModelChange)="aoMudarObservacao()" />Alterar observação</label>
            <textarea
              aria-label="Observação"
              rows="3"
              maxlength="500"
              [(ngModel)]="e.observacao"
              (ngModelChange)="aoMudarObservacao()"
              [disabled]="!e.alterarObservacao"
              [placeholder]="linhas.length > 1 ? 'Novo texto para todos os selecionados' : 'Observação do agendamento'"
            ></textarea>
            <p class="dica">Só grava nos agendamentos em que o texto muda.</p>
            <div class="alerta bad" *ngIf="pedindoConfirmacao" role="alert">
              <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
              <div>O texto está vazio: isso <b>apaga a observação de {{ apagaObservacao }} agendamento{{ apagaObservacao > 1 ? 's' : '' }}</b>. Confirme no botão abaixo ou escreva o texto.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultado por linha -->
    <div class="modal-corpo" *ngIf="resultados">
      <div class="alerta" [class.ok]="!salvando && !resumo.erro" [class.warn]="salvando || resumo.erro" role="status">
        <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
        <div *ngIf="salvando">Aplicando... {{ resultados.length }} de {{ linhas.length }}.</div>
        <div *ngIf="!salvando">
          <b>{{ resumo.ok }}</b> alteraç{{ resumo.ok === 1 ? 'ão gravada' : 'ões gravadas' }}<ng-container *ngIf="resumo.erro">, <b>{{ resumo.erro }}</b> recusada{{ resumo.erro > 1 ? 's' : '' }}</ng-container><ng-container *ngIf="resumo.pulado">, {{ resumo.pulado }} pulada{{ resumo.pulado > 1 ? 's' : '' }}</ng-container>. A grade foi atualizada.
        </div>
      </div>
      <div class="mini-wrap alto">
        <table class="mini">
          <thead><tr><th>Hora</th><th>Paciente</th><th>Resultado</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of resultados">
              <td><b>{{ r.linha.hrInicio }}</b></td>
              <td>{{ r.linha.paciente.nmPaciente || '—' }}</td>
              <td class="itens">
                <div *ngFor="let i of r.itens" class="item" [ngClass]="'s-' + i.situacao">
                  <span class="selo" [class.ok]="i.situacao === 'ok'" [class.bad]="i.situacao === 'erro'" [class.cinza]="i.situacao === 'igual'" [class.warn]="i.situacao === 'pulado'">
                    {{ i.rotulo }}{{ i.situacao === 'ok' ? ' ✓' : i.situacao === 'erro' ? ' ✗' : '' }}
                  </span>
                  <span class="msg-item">{{ i.mensagem }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-rod">
      <ng-container *ngIf="!resultados">
        <span class="msg" *ngIf="faltando.length">Falta: {{ faltando.join(', ') }}</span>
        <button type="button" class="btn btn-contorno" (click)="cancelar()">Voltar</button>
        <button *ngIf="pedindoConfirmacao" type="button" class="btn btn-perigo" (click)="confirmarApagar()">
          Apagar a observação de {{ apagaObservacao }}
        </button>
        <button *ngIf="!pedindoConfirmacao" type="button" class="btn btn-primario" (click)="aplicar()" [disabled]="!!faltando.length">
          <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>Aplicar em {{ linhas.length }}
        </button>
      </ng-container>
      <button *ngIf="resultados" type="button" class="btn btn-primario" (click)="cancelar()" [disabled]="salvando">
        {{ salvando ? 'Aplicando...' : 'Fechar' }}
      </button>
    </div>
  </div>
</div>
